import { Button, Select } from "antd";
import { memo, useEffect, useState } from "react";
import styles from "./Then.module.css";
import ConvertNumbersToEn from "../../../Util/ConvertNumbersToEn";

const Then = (props) => {
  const { onChange, questions, arrayOfConditions, thenId } = props;
  let selectedQuestion = null;

  const [duplicateError, setDuplicateError] = useState(false);

  useEffect(() => {
    const thenEl = arrayOfConditions
      .find((e) => e?.then?.find((el) => el.id === thenId))
      ?.then?.find((e) => e.id === thenId);

    const conflictThen = arrayOfConditions?.find((cond) =>
      cond?.then?.some(
        (e) =>
          e?.target?.questionId == thenEl?.target?.questionId &&
          e?.target?.answerId == thenEl?.target?.answerId &&
          e?.id !== thenId
      )
    );

    setDuplicateError(conflictThen);
  }, [arrayOfConditions]);

  for (let i = 0; i < questions.length; i++) {
    const element = questions[i];
    const questionId = `${element.id}`;
    if (questionId === `${props.target.questionId}`) {
      selectedQuestion = element;
      break;
    } else if (Array.isArray(element.questions)) {
      for (let j = 0; j < element.questions.length; j++) {
        const subQ = element.questions[j];
        const subQId = `${subQ.id}`;
        if (subQId === `${props.target.questionId}`) {
          selectedQuestion = subQ;
          break;
        }
      }
    }
  }

  const getIndex = (id) => {
    return questions
      .filter((e) => e.field_type !== "break" && e.field_type !== "html")
      .findIndex((v) => v.id === id);
  };

  const getSubIndex = (qaId, optId) => {
    const qaIndex = getIndex(qaId);

    const optIndex = questions
      .find((e) => e.id === qaId)
      ?.questions?.findIndex((e) => e.id == optId);

    return `${qaIndex + 1}.${optIndex + 1}`;
  };

  return (
    <div
      style={{
        ...(duplicateError && {
          border: "5px solid red",
          borderRadius: "5px",
          padding: "3px",
          paddingLeft: "1.3rem",
        }),
        width: "100%",
      }}
    >
      <div className={styles.Then}>
        <Select
          onChange={(value) => onChange("action", value)}
          value={props.action}
        >
          <Select.Option value="hide">پنهان کردن</Select.Option>;
          <Select.Option value="show">نمایش دادن</Select.Option>;
          <Select.Option value="activateOption">فعال کردن گزینه</Select.Option>;
        </Select>
        <Select
          showSearch
          filterOption={(input, option) => {
            return option.textLabel?.search(ConvertNumbersToEn(input)) !== -1;
          }}
          onChange={(value) => {
            onChange("target", {
              ...props.target,
              questionId: value,
            });
          }}
          value={props.target.questionId ? `${props.target.questionId}` : null}
        >
          {questions.map((q) => {
            const questionId = q.id ? `${q.id}` : null;
            if (Array.isArray(q.questions) && q.questions.length > 0) {
              return (
                <Select.OptGroup
                  textLabel={`${getIndex(q.id) + 1} - ${q.label}`}
                  label={
                    <p>
                      {getIndex(q.id) + 1} - {q.label}
                    </p>
                  }
                >
                  <Select.Option
                    value={`${q.id}`}
                    textLabel={`${getSubIndex(q.id)} - تمامی سوالات`}
                  >
                    {`${getSubIndex(q.id)} - تمامی سوالات`}
                  </Select.Option>
                  {q.questions.map((subQ) => {
                    const subQId = subQ.id ? `${subQ.id}` : null;
                    return (
                      <Select.Option
                        value={subQId}
                        textLabel={`${getSubIndex(q.id, subQId)} - ${
                          subQ.label
                        }`}
                      >
                        {getSubIndex(q.id, subQId)} - {subQ.label}
                      </Select.Option>
                    );
                  })}
                </Select.OptGroup>
              );
            }

            return (
              <Select.Option
                value={questionId}
                textLabel={
                  q.field_type !== "html" && q.field_type !== "break"
                    ? `${getIndex(q.id) + 1} - ${q.label}`
                    : `${q.label}`
                }
              >
                {q.field_type !== "html" && q.field_type !== "break" && (
                  <p1>{getIndex(q.id) + 1} - </p1>
                )}
                {q.label}
              </Select.Option>
            );
          })}
        </Select>

        {selectedQuestion &&
        Array.isArray(selectedQuestion.options) &&
        selectedQuestion.options.length > 0 ? (
          <Select
            showSearch
            filterOption={(input, option) => {
              return option?.children?.search(ConvertNumbersToEn(input)) !== -1;
            }}
            value={props.target.answerId}
            onChange={(value) => {
              onChange("target", { ...props.target, answerId: value });
            }}
          >
            <Select.Option value={null}>کل گزینه ها</Select.Option>
            {selectedQuestion &&
              Array.isArray(selectedQuestion.options) &&
              selectedQuestion.options.map((opt) => {
                const optionId = `${opt.id}`;
                return (
                  <Select.Option value={optionId}>{opt.label}</Select.Option>
                );
              })}
          </Select>
        ) : (
          <div style={{ textAlign: "center" }}> - </div>
        )}
      </div>

      {duplicateError && (
        <Button style={{ width: "100%", marginTop: "0.3rem" }}>
          خطا در بلوک: {duplicateError?.title}
        </Button>
      )}
    </div>
  );
};

export default memo(Then);
